import React from "react";

const SchedulerStatus = [
  {
    label: "Completed",
    value: "COMPLETED",
  },
  {
    label: "Not Yet Started",
    value: "NOT_YET_STARTED",
  },
  {
    label: "Cancelled",
    value: "CANCELLED",
  },
];

export default SchedulerStatus;
